import React from "react";
import { Helmet } from "react-helmet";
import { navigate } from "hookrouter";
import { colors, serif, sans } from "../../theme/brand";

function App404() {
  return (
    <div style={{ animation: "fadeUp .5s ease both" }}>
      <Helmet>
        <title>Pagina niet gevonden — Datails</title>
        <meta name="description" content="Sorry, deze pagina bestaat niet." />
      </Helmet>
      <section style={{ maxWidth: 1120, margin: "0 auto", padding: "120px 32px", textAlign: "center" }}>
        <p style={{ fontFamily: serif, fontSize: "clamp(64px,10vw,120px)", color: colors.teal, lineHeight: 1 }}>404</p>
        <h1 style={{ fontFamily: serif, fontWeight: 400, fontSize: "clamp(30px,4vw,48px)", lineHeight: 1.06, marginTop: 8 }}>
          Deze pagina bestaat niet.
        </h1>
        <p style={{ fontSize: 18, lineHeight: 1.55, color: colors.textMuted, marginTop: 20, maxWidth: 460, marginLeft: "auto", marginRight: "auto" }}>
          De pagina die je zoekt is verplaatst of bestaat niet meer.
        </p>
        <button
          onClick={() => navigate("/")}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 9,
            background: colors.teal,
            color: "#FBF7EF",
            border: "none",
            cursor: "pointer",
            fontFamily: sans,
            padding: "15px 28px",
            borderRadius: 999,
            fontSize: 16,
            fontWeight: 600,
            marginTop: 32,
          }}
        >
          Terug naar home
        </button>
      </section>
    </div>
  );
}

export default App404;
